export class OngoingDraftResponse {
  constructor({status, draftEntity}) {
    this._status = status
    this._data = draftEntity
  }

  status() {
    return this._status
  }

  data() {
    return this._data.toJSON()
  }

  toJSON() {
    return {
      ...(this._status && {status: this.status()}),
      ...(this._data && {data: this.data()})
    }
  }
}
